import React, { useState } from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import IMG1 from "../../images/location/san-diego/android-app.png";
import IMG3 from "../../images/location/san-diego/crossplatform.png";
import IMG2 from "../../images/location/san-diego/iOS.png";
import IMG4 from "../../images/location/san-diego/mobile-game.png";
import IMG6 from "../../images/location/san-diego/SaaS.png";
import IMG5 from "../../images/location/san-diego/super-app.png";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Carousel from "react-multi-carousel";
import Slide1 from "../../images/location/atlanta/android.png";
import Slide2 from "../../images/location/atlanta/ios-1.png";
import Slide3 from "../../images/location/atlanta/mob-game-1.png";
import Slide4 from "../../images/location/atlanta/custom-app-1.png";


const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 1600},
        items: 3
    },
    desktop: {
        breakpoint: {max: 1599, min: 1400},
        items: 3
    },
    tabletlandscape: {
        breakpoint: {max: 1399, min: 1200},
        items: 3
    },
    tablet: {
        breakpoint: {max: 1199, min: 1024},
        items: 2
    },
    tablet1: {
        breakpoint: {max: 1023, min: 667},
        items: 1
    },
    mobile: {
        breakpoint: {max: 666, min: 0},
        items: 1
    }
};




function Harnessing(props) {
    // const [activeOffer, setActiveOffer] = useState(0);
    //
    // const toggleOffer = (offerIndex) => {
    //     setActiveOffer(offerIndex === activeOffer ? -1 : offerIndex);
    // };


    return (
        <div className="harness p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={7} className="my-auto">
                        <div className="example" data-text="Digitized">
                            <h2>Experience Custom App Solutions by Our Seattle App Developers</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={5}>
                        <p>A tailor-made application can take the user experience to the next level. You can provide a personalized experience to the customers by building custom functionalities and components that suit your brand. Our Seattle app developers utilize their expertise in producing a custom mobile with rich features to facilitate the users in the best possible way.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Lets Connect!
                        </Link>
                    </Col>
                </Row>
            </Container>

            <Container className="cont-extra">
                {/*<Row>*/}
                    {/*<Col xs={12} md={12} lg={12} xl={12} xxl={12}>*/}
                        {/*<div className="offer-area section">*/}
                            {/*<div className="heading-area">*/}
                                {/*<div className="container1">*/}
                                    {/*<div className="offer-tab-link">*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                            {/*<div className="offer-tabs tab-content">*/}
                                {/*<div className="offerslide tab-pane fade active show" id="SOLUTIONS">*/}

                                    {/*<div*/}
                                        {/*className={`offerItem ${activeOffer === 0 ? 'active' : ''}`}*/}
                                        {/*onClick={() => toggleOffer(0)}*/}
                                    {/*>*/}
                                        {/*<h4 className="offerItemTitle hide">Android Apps</h4>*/}
                                        {/*<div className="offer-detail">*/}
                                            {/*<div className="row">*/}
                                                {/*<div className="col-12">*/}
                                                {/*</div>*/}
                                                {/*<div className="col-12">*/}
                                                    {/*<div className="offer-content">*/}
                                                        {/*<div className="offer-img">*/}
                                                            {/*<LazyLoadImage*/}
                                                                {/*src={IMG1}*/}
                                                                {/*effect="blur" alt="IMG7" className="img-fluid"*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        {/*<h3>Android Apps</h3>*/}
                                                            {/*We create Android apps powered by Java and Kotlin: programming languages that are highly sustainable and scalable. In addition to the powerful programming languages, the Android development pool is expanding each day.*/}
                {/*<p>Android apps empower you to claim real business disruption because it has the biggest share in the smartphone industry. Almost 71% of smartphone users own an Android-powered device. While all businesses are capitalizing on the platform’s user base, TekRevol can help you leverage the easy entry to the Android market.*/}
                {/*TekRevol helps entrepreneurs tap the innovative potential of the platform by creating Android apps that offer business-level monetization, and high-end user experience.*/}
                {/*</p>*/}
                                                        {/*<Link to="/contact"*/}
                                                              {/*className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}

                                    {/*<div*/}
                                        {/*className={`offerItem ${activeOffer === 1 ? 'active' : ''}`}*/}
                                        {/*onClick={() => toggleOffer(1)}*/}
                                    {/*>*/}
                                        {/*<h4 className="offerItemTitle">iOS Apps</h4>*/}
                                        {/*<div className="offer-detail">*/}
                                            {/*<div className="row">*/}
                                                {/*<div className="col-12">*/}
                                                {/*</div>*/}
                                                {/*<div className="col-12">*/}
                                                    {/*<div className="offer-content">*/}
                                                        {/*<div className="offer-img">*/}
                                                            {/*<LazyLoadImage*/}
                                                                {/*src={IMG2}*/}
                                                                {/*effect="blur" alt="IMG7" className="img-fluid"*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        {/*<h3>iOS Apps</h3>*/}
                                                        {/*<p>iOS apps have the strongest user base that prioritizes app experience, one-touch functionality and responsiveness. TekRevol has an edge in iOS app development. Our teams utilize the extensive collection of Apple’s official development resources and tools. We offer apps that are functional and consistent in interface.</p>*/}
                                                        {/*<p>We create iOS apps powered by Objective C, Swift, and XCode – and use this stable yet dynamic, feature-rich trio conveniently for scaling iPhone and iPad apps.</p>*/}
                                                        {/*<Link to="/contact"*/}
                                                              {/*className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}

                                    {/*<div*/}
                                        {/*className={`offerItem ${activeOffer === 2 ? 'active' : ''}`}*/}
                                        {/*onClick={() => toggleOffer(2)}*/}
                                    {/*>*/}
                                        {/*<h4 className="offerItemTitle">Crossplatform Apps</h4>*/}
                                        {/*<div className="offer-detail">*/}
                                            {/*<div className="row">*/}
                                                {/*<div className="col-12">*/}
                                                {/*</div>*/}
                                                {/*<div className="col-12">*/}
                                                    {/*<div className="offer-content">*/}
                                                        {/*<div className="offer-img">*/}
                                                            {/*<LazyLoadImage*/}
                                                                {/*src={IMG3}*/}
                                                                {/*effect="blur" alt="IMG7" className="img-fluid"*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        {/*<h3>Crossplatform Apps</h3>*/}
                                                        {/*<p>Crossplatform apps are the most cost-effective option for businesses that want to launch an app with a single codebase for diverse audiences and devices. We create crossplatform apps for early adopters and innovators who want to optimize development budgets, reduce development time, and launch the digital product faster than the competition.</p>*/}
                                                        {/*<p>At TekRevol, we use custom technology stacks for creating crossplatform applications – and most frameworks use Flutter, React Native, and related libraries.</p>*/}
                                                        {/*<Link to="/contact"*/}
                                                              {/*className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}
                                    {/*<div*/}
                                        {/*className={`offerItem ${activeOffer === 3 ? 'active' : ''}`}*/}
                                        {/*onClick={() => toggleOffer(3)}*/}
                                    {/*>*/}
                                        {/*<h4 className="offerItemTitle">Mobile Games</h4>*/}
                                        {/*<div className="offer-detail">*/}
                                            {/*<div className="row">*/}
                                                {/*<div className="col-12">*/}
                                                {/*</div>*/}
                                                {/*<div className="col-12">*/}
                                                    {/*<div className="offer-content">*/}
                                                        {/*<div className="offer-img">*/}
                                                            {/*<LazyLoadImage*/}
                                                                {/*src={IMG4}*/}
                                                                {/*effect="blur" alt="IMG7" className="img-fluid"*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        {/*<h3>Mobile Games</h3>*/}
                                                        {/*<p>Games are forecasted to bring more revenue than other best-selling sectors in the entertainment industry. TekRevol builds future-proof games with stunning graphics, high-end player experience, and ready monetization strategies. </p>*/}
                                                        {/*<p>We use robust game development frameworks based on Unity and Unreal Engine. Our developers leverage emerging technologies to skyrocket the success of game startups, so you’ll see that most of our games are success stories built on blockchain architectures, VR frameworks, machine learning algorithms and robotics.</p>*/}
                                                        {/*<Link to="/contact"*/}
                                                              {/*className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}
                                    {/*<div*/}
                                        {/*className={`offerItem ${activeOffer === 4 ? 'active' : ''}`}*/}
                                        {/*onClick={() => toggleOffer(4)}*/}
                                    {/*>*/}
                                        {/*<h4 className="offerItemTitle">Super apps </h4>*/}
                                        {/*<div className="offer-detail">*/}
                                            {/*<div className="row">*/}
                                                {/*<div className="col-12">*/}
                                                {/*</div>*/}
                                                {/*<div className="col-12">*/}
                                                    {/*<div className="offer-content">*/}
                                                        {/*<div className="offer-img">*/}
                                                            {/*<LazyLoadImage*/}
                                                                {/*src={IMG5}*/}
                                                                {/*effect="blur" alt="IMG7" className="img-fluid"*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        {/*<h3>Super apps </h3>*/}
                                                        {/*<p>Super applications are mobile apps with a highly comprehensive scope. Unlike typical on-demand applications, it has a set of features that allow various functionalities under one interface. We create super apps that provide a high-end user experience to target stakeholders of the app.</p>*/}
                                                        {/*<p>To ensure we create super apps with cutting-edge use cases, we do strong competitor research, study pain points from 50+ niche platforms online and in person, then come up with comprehensive scope for discovery. We use cloud-native solutions, the strongest databases, back-end and front-end frameworks and latest APIs to create business-level super apps. </p>*/}
                                                        {/*<Link to="/contact"*/}
                                                              {/*className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}
                                    {/*<div*/}
                                        {/*className={`offerItem ${activeOffer === 5 ? 'active' : ''}`}*/}
                                        {/*onClick={() => toggleOffer(5)}*/}
                                    {/*>*/}
                                        {/*<h4 className="offerItemTitle">SaaS Apps </h4>*/}
                                        {/*<div className="offer-detail">*/}
                                            {/*<div className="row">*/}
                                                {/*<div className="col-12">*/}
                                                {/*</div>*/}
                                                {/*<div className="col-12">*/}
                                                    {/*<div className="offer-content">*/}
                                                        {/*<div className="offer-img">*/}
                                                            {/*<LazyLoadImage*/}
                                                                {/*src={IMG6}*/}
                                                                {/*effect="blur" alt="IMG7" className="img-fluid"*/}
                                                            {/*/>*/}
                                                        {/*</div>*/}
                                                        {/*<h3>SaaS Apps </h3>*/}
                                                        {/*<p>SaaS apps are typically built and launched by business organizations that want to expand their reach beyond devices and operating systems. TekRevol provides sophisticated software development services covering a diverse range of niches including productivity apps, Enterprise Resource Planning (ERP) programs and other cloud-based solutions. </p>*/}
                                                        {/*<p>We have an alpha team of creative designers, developers, QA professionals and marketing experts experienced in taking SaaS ideation to execution, launch and subscription monetization. </p>*/}
                                                        {/*<Link to="/contact"*/}
                                                              {/*className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</Col>*/}
                {/*</Row>*/}

                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000}
                                  arrows={false} className="carousel_featured">

                            <div className="featured_item">
                                <div className="cutting-slide texas-slide">
                                    <div className="featured_img">
                                        <LazyLoadImage
                                            src={Slide1}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                    <h5>Android App Development</h5>
                                    <p>Having a maximum number of users using Android OS, you can target your audience by building a stunning mobile app. Our Android app developers Seattle have specialized in building full-fledged Android applications. For that purpose, they utilize suitable technologies like Java, Kotlin, and the latest frameworks including Flutter or React Native. With personalized experience according to the custom functionality, you can set a great impression for your business online. Further, you can streamline your operation with high-end performance based on efficient results.
                                    </p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="cutting-slide texas-slide">
                                    <div className="featured_img">
                                        <LazyLoadImage
                                            src={Slide2}
                                            effect="blur" alt="Tab_01" className="img-fluid "
                                        />
                                    </div>
                                    <h5>iOS App Development</h5>
                                    <p>You can rely on our iPhone app developers Seattle to develop your application specifically for iOS. We abide by the rules of iOS app development and build complex functionalities using our expertise. By utilizing technologies like Objective-C and Swift, we build a full-scale iPhone app to digitize any business. Moreover, we encompass the new trends of mobile app development in our app design to provide a pleasing UI that gets the audience engagement. As a result, you will have better opportunities to convert your customers with a rich features app</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="cutting-slide texas-slide">
                                    <div className="featured_img">
                                        <LazyLoadImage
                                            src={Slide3}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                    <h5>Game Development</h5>
                                    <p>Get real-world experience with our top-notch game app development based on the latest technologies like AR and VR. We incorporate incredible gadgets considering the new trends in the gaming industry. So, you can engage the audience with tremendous features that will provide an enjoyable experience. You can consult with our app developers Seattle and they will help you craft the idea by the full-fledged development of your game. We’ll also help you enhance the whole concept of your game based on our experience in the field.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="cutting-slide texas-slide">
                                    <div className="featured_img">
                                        <LazyLoadImage
                                            src={Slide4}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                    <h5>Healthcare App Development</h5>
                                    <p>The healthcare industry has taken the maximum benefit from mobile app development and we can help you set a new mark with an exceptional app. Our expert healthcare app developers Seattle have enough experience in building large-scale applications. Using a major technology stack, we develop seamless applications on different platforms. You can automate your daily tasks within the healthcare facility and provide a better experience to the customers that will result in better treatment.</p>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="cutting-slide texas-slide">
                                    <div className="featured_img">
                                        <LazyLoadImage
                                            src={Slide4}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                    <h5>E-commerce app Development</h5>
                                    <p>The ecommerce industry is on the verge of maximum growth and the main reason behind it is the increasing number of mobile applications to operate ecommerce businesses. Using the expertise of our app developers in Seattle, we can create a stunning e-commerce platform with seamless functionality. That’s how you can create a great influence on the buyers presenting your business in an appropriate digital manner. As a result, your sales will grow by far and the e-commerce business will be sustained</p>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="cutting-slide texas-slide">
                                    <div className="featured_img">
                                        <LazyLoadImage
                                            src={Slide4}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                    <h5>Cross-Platform App Development</h5>
                                    <p>You can reach the maximum number of users by developing a cross-platform app targeting both Android and iOS platforms. We have the best app developers Seattles who utilize their skills in cross-platform app development. Using the latest Flutter framework for mobile apps, they develop an app for both Android and iPhone users. It enables you to approach a huge audience targeting both platforms while using the same code making it affordable for businesses to digitize their operations</p>
                                </div>
                            </div>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Harnessing;